var map = {
	"./A2ACellings.svg": 85971,
	"./CheckoutIcon": 33977,
	"./CheckoutIcon.vue": 33977,
	"./Correction.svg": 6946,
	"./Done.svg": 88566,
	"./Done_Down.svg": 24663,
	"./Failed.svg": 61811,
	"./IPG.svg": 18378,
	"./Ipg-warning.svg": 45137,
	"./IpgPending.svg": 43718,
	"./IpgPendingNew.svg": 22847,
	"./IpgVip.svg": 88516,
	"./P2P.svg": 76216,
	"./PaymentForm.svg": 99637,
	"./Payment_Form.svg": 40614,
	"./Subscribe.svg": 19204,
	"./Union.svg": 17145,
	"./accountantIcon": 28029,
	"./accountantIcon.vue": 28029,
	"./add-user.svg": 18235,
	"./add_business.svg": 58297,
	"./ascending_pack.svg": 59341,
	"./autoCashIn.svg": 16298,
	"./ayandehLogo.svg": 45266,
	"./banksLogoCollection.svg": 77866,
	"./cancel.svg": 82644,
	"./cash-in-icon.svg": 42475,
	"./cash-in-manual.svg": 77577,
	"./cashInPending.svg": 37415,
	"./check.svg": 28257,
	"./contract.svg": 87826,
	"./contractIcon.svg": 80263,
	"./daily-report.svg": 74123,
	"./error.svg": 44502,
	"./error_close.svg": 19443,
	"./failed-circle.svg": 63198,
	"./file-excel-outline.svg": 8958,
	"./grayLocation.svg": 2426,
	"./homeTools.svg": 96365,
	"./iBan.svg": 55070,
	"./ibanShaparak.svg": 60782,
	"./ibans.svg": 69623,
	"./info.svg": 62292,
	"./information.svg": 64826,
	"./internetBank.svg": 60748,
	"./ipg-document.svg": 9118,
	"./ipg-square.svg": 22384,
	"./ipgDialog.svg": 52946,
	"./ipgDialogNew.svg": 4229,
	"./kerdar.svg": 96372,
	"./key.svg": 789,
	"./loading-circle.gif": 88742,
	"./location.svg": 38898,
	"./lock.svg": 59355,
	"./miandoPending.svg": 4124,
	"./p2pPending.svg": 41164,
	"./payment_form_card.svg": 49870,
	"./pbvFirstTime.svg": 3502,
	"./pbvPending.svg": 62471,
	"./pending-square-yellow.svg": 98015,
	"./pendingBusiness.svg": 79282,
	"./receipt.svg": 91821,
	"./refundPending.svg": 61015,
	"./request_money.svg": 993,
	"./sandbox.svg": 25399,
	"./settlement_batch_gray.svg": 74086,
	"./shaparak.svg": 6640,
	"./simple-check.svg": 54289,
	"./subscribePending.svg": 31326,
	"./taxID.svg": 1417,
	"./tools/A2A.svg": 33747,
	"./tools/MPG.svg": 36244,
	"./tools/PBV.svg": 98827,
	"./tools/accountant.svg": 61608,
	"./tools/cash-in.svg": 23523,
	"./tools/customer.svg": 17428,
	"./tools/fee.svg": 16860,
	"./tools/inquiry.png": 91932,
	"./tools/ipg.svg": 42663,
	"./tools/kerdar.svg": 3124,
	"./tools/log.svg": 26064,
	"./tools/miando.svg": 6280,
	"./tools/moghayerat.svg": 55281,
	"./tools/p2p.svg": 52350,
	"./tools/p2p_new.svg": 77435,
	"./tools/pos.svg": 35701,
	"./tools/reconciliation.svg": 10062,
	"./tools/refund.svg": 32062,
	"./tools/request-money.svg": 1345,
	"./tools/requestMoney.svg": 21166,
	"./tools/settlement.svg": 62161,
	"./tools/settlement_batch.svg": 10004,
	"./tools/subscription.svg": 14175,
	"./tools/success.svg": 51153,
	"./tools/tools.svg": 21474,
	"./tools/total.svg": 88679,
	"./transaction-turnover.svg": 11821,
	"./wallet.svg": 95498,
	"./warning-circle.svg": 66310,
	"./warning.svg": 88709,
	"./whatsnew-white.svg": 81343,
	"./whatsnew.svg": 75091,
	"./whatsnewToolbar.svg": 13008,
	"./yellowInfo.svg": 83196,
	"./yellowWarning.svg": 7534,
	"./yellow_box_ipg_vip_icon.svg": 29581,
	"./yellow_info.svg": 12836
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 90427;